import React from "react";
export const CalanderIconFilter=()=>{
    return(
        <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.062rem"
      height="1rem"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M13.5 2.5H3.5C3.22386 2.5 3 2.72386 3 3V13C3 13.2761 3.22386 13.5 3.5 13.5H13.5C13.7761 13.5 14 13.2761 14 13V3C14 2.72386 13.7761 2.5 13.5 2.5Z"
        stroke="#6C707E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 1.5V3.5"
        stroke="#6C707E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 1.5V3.5"
        stroke="#6C707E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 5.5H14"
        stroke="#6C707E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    )
}